module.exports = __webpack_public_path__ + "static/img/application11-2.6fb0850.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application11-2.jpg
// module id = FLar
// module chunks = 0